import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TemplateTabLayout } from '../TemplateTabLayout';
import { WorkPathTemplatesList } from './WorkPathTemplatesList';
import { WorkPathTemplateFormDialog } from './WorkPathTemplateFormDialog';
import type { WorkPathTemplate } from '@/hooks/useWorkPaths';

export function WorkPathTemplatesTab() {
  const { t } = useTranslation('workpaths');
  const [editTemplate, setEditTemplate] = useState<WorkPathTemplate | null>(null);

  return (
    <TemplateTabLayout
      title={t('template.title')}
      subtitle={t('template.subtitle')}
      createLabel={t('template.create')}
      showInactiveLabel={t('template.showInactive')}
      isEditing={editTemplate !== null}
      onCloseDialog={() => setEditTemplate(null)}
      renderList={(includeInactive) => (
        <WorkPathTemplatesList onEdit={setEditTemplate} includeInactive={includeInactive} />
      )}
      renderDialog={(open, onClose) => (
        <WorkPathTemplateFormDialog open={open} onClose={onClose} template={editTemplate} />
      )}
    />
  );
}
